var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.7 108.2",
    style: {
      enableBackground: "new 0 0 684.7 108.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#F9116C;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M92.7,99H20.4c-5.9,0-10.7-4.8-10.7-10.7V18.9c0-5.9,4.8-10.7,10.7-10.7h72.3c5.9,0,10.7,4.8,10.7,10.7v69.4 C103.4,94.2,98.6,99,92.7,99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.8,84.1h-8.7V23.1h8.7V84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.2,23.1l17.4,22.7l17.4-22.7h8.7v61.1h-8.7V37.4l-13.1,17v5.1h-8.7v-5.1l-13.1-17v46.7h-8.7V23.1H149.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M210.3,23.1l17.4,22.7l17.4-22.7h8.7v61.1h-8.7V37.4l-13.1,17v5.1h-8.7v-5.1l-13.1-17v46.7h-8.7V23.1H210.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M297.5,71v-48h8.7v48c0,0.7,0,1.2-0.1,1.6c-0.3,2.7-1.7,5.2-3.9,7.5c-2.3,2.3-4.9,3.6-7.9,3.9 c-0.3,0.1-0.7,0.1-1.2,0.1h-17.4c-0.5,0-0.9,0-1.2-0.1c-2.9-0.2-5.6-1.5-7.9-3.9c-2.2-2.3-3.5-4.8-3.8-7.5 c-0.1-0.3-0.1-0.9-0.1-1.6v-48h8.7v48c0,1,0.5,2,1.4,2.9c1,1,1.9,1.4,2.9,1.4h17.4c1,0,2-0.5,3-1.4C297,73,297.5,72,297.5,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M358.6,84.1h-8.7l-26.2-45.4v45.4h-8.7V23.1h8.7l26.2,45.4V23.1h8.7V84.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M410.9,23.1v8.7H376v17.4h26.2v8.7H376v17.4h34.9v8.7h-43.6V23.1H410.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M463.2,36.1v8.7c0,3.3-1.1,6.2-3.3,8.7c2.2,2.6,3.3,5.5,3.3,8.7V71c0,3.6-1.3,6.7-3.8,9.2 c-2.6,2.6-5.6,3.8-9.2,3.8h-30.5V23.1h30.5c3.6,0,6.7,1.3,9.2,3.8C461.9,29.5,463.2,32.5,463.2,36.1z M450.1,31.8h-21.8v17.4h21.8 c1.2,0,2.3-0.4,3.1-1.3c0.8-0.8,1.3-1.9,1.3-3.1v-8.7c0-1.2-0.4-2.3-1.3-3.1C452.4,32.2,451.4,31.8,450.1,31.8z M454.5,71v-8.7 c0-1.2-0.4-2.3-1.3-3.1c-0.8-0.8-1.9-1.3-3.1-1.3h-21.8v17.4h21.8c1.2,0,2.3-0.4,3.1-1.3C454.1,73.3,454.5,72.3,454.5,71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M506.8,34.3V23.1h8.7v13.1c0,1.3-0.4,2.3-1.3,3.1l-16.1,16.2v28.7h-8.7V55.4l-16.1-16.2 c-0.9-0.8-1.3-1.8-1.3-3.1V23.1h8.7v11.3l13.1,13.1L506.8,34.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M524.3,23.1h43.6v8.7h-17.4v52.3h-8.7V31.8h-17.4V23.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M620.2,23.1v8.7h-34.9v17.4h26.2v8.7h-26.2v17.4h34.9v8.7h-43.6V23.1H620.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.3,84.1h-17.4c-3.6,0-6.7-1.3-9.2-3.8c-2.6-2.6-3.8-5.6-3.8-9.2v-2.7h8.7V71c0,1.2,0.4,2.3,1.3,3.1 c0.8,0.8,1.9,1.3,3.1,1.3h17.4c1.2,0,2.3-0.4,3.1-1.3c0.8-0.8,1.3-1.9,1.3-3.1v-4.3c-0.1-1.3-0.8-2.3-2.3-3.1l-25.7-12.4 c-2.3-1.3-4-2.9-5.1-4.9c-1.2-2-1.7-3.9-1.7-5.8v-4.4c0-3.6,1.3-6.7,3.8-9.2c2.6-2.6,5.6-3.8,9.2-3.8h17.4c3.6,0,6.7,1.3,9.2,3.8 c2.6,2.6,3.8,5.6,3.8,9.2v2.7h-8.7v-2.7c0-1.2-0.4-2.3-1.3-3.1c-0.8-0.8-1.9-1.3-3.1-1.3h-17.4c-1.2,0-2.3,0.4-3.1,1.3 c-0.8,0.8-1.3,1.9-1.3,3.1v4.3c0.1,1.3,0.8,2.3,2.3,3.1l25.7,12.4c2.3,1.3,4,2.9,5.1,4.9c1.2,2,1.7,3.9,1.7,5.8V71 c0,3.6-1.3,6.7-3.8,9.2C664,82.8,660.9,84.1,657.3,84.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M70.5,73c-3.7,1.7,5.6,4.4,3.3-6.2C73.8,66.8,74.2,71.3,70.5,73z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "21.1,36.9 22.1,37.9 34.6,37.9 34.6,25.7 33.2,24.5 31.5,23.1 20.1,23.1 20.1,35.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M86.1,51.8l5.1-4.3V33.2L81.1,23.1H42.7v61.1h5.7l5-6.3c0.8-1,2.4-1.2,3.4-0.4c1,0.8,1.2,2.4,0.4,3.4 l-2.6,3.3h28.3L93,74V57.6L86.1,51.8z M59.5,37.1h14.1v9.9H59.5V37.1z M77.8,71.1c-0.2,0.5-0.4,0.9-0.7,1.4 c-0.3,0.5-0.6,1.1-1,1.6c-0.3,0.4-0.6,0.7-0.9,1c-4.1,4-10.6,4.5-15.2,0.8c-0.3-0.3-0.6-0.5-0.9-0.8c-3.8-3.8-4.5-9.7-1.7-14.2 c0.2-0.4,0.5-0.7,0.7-1.1c0.6-0.7,1.2-1.3,1.9-1.8c4.1-3.2,10-3.4,14.3,0c0,0,0,0,0,0c1.6,1.3,2.8,3,3.5,4.8 C78.8,65.3,78.9,68.3,77.8,71.1z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "31.7,53.9 31.7,45.9 24.2,45.9 24.2,43.2 20.1,43.2 20.1,84.1 34.6,84.1 34.6,53.9  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "59.5,63.6 61.1,60.6 64.9,59 62.2,60.7  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.0be82476dc4d0e9867bd7ea43c845537.svg";
export { ForwardRef as ReactComponent };